import { IconProps } from '../../../lib/types';

const Format: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.847"
      height="30.192"
      viewBox="0 0 33.847 30.192"
      className={className}
    >
      <defs>
        {/* <style>
      .a {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        stroke-width: 3px;
      }


    </style> */}
      </defs>
      <g transform="translate(0 1.5)">
        <path
          className="fill-transparent"
          strokeMiterlimit={10}
          d="M104.16,93.705h24.5V78.96h-24.5Z"
          transform="translate(-99.764 -78.96)"
        />
        <path
          d="M233.115,117.678a2.318,2.318,0,1,1-2.318-2.318,2.294,2.294,0,0,1,2.318,2.318"
          transform="translate(-220.208 -112.763)"
        />
        <path
          d="M204.477,130.315l4.276-4.555-.919-.879-3.6,3.756a3.472,3.472,0,0,1-1.8.839h-3.517a2.934,2.934,0,0,0-2.917,2.917v5.874h1.279v-4.875a.24.24,0,1,1,.479,0V144.82H200.2v-6.034a.479.479,0,1,1,.959,0v6.074h2.518V133.432a4.721,4.721,0,0,1,.8-3.117Z"
          transform="translate(-190.052 -121.603)"
        />
        <path
          d="M144.555,374.116a2.278,2.278,0,1,1-2.278-2.278,2.278,2.278,0,0,1,2.278,2.278"
          transform="translate(-138.042 -350.939)"
        />
        <path
          d="M118.716,444.64h-3.8a2.255,2.255,0,0,0-2.358,2.2v.4h8.432v-.4A2.186,2.186,0,0,0,118.716,444.64Z"
          transform="translate(-112.562 -418.546)"
        />
        <path
          d="M500.716,374.116a2.278,2.278,0,1,1-2.278-2.278,2.278,2.278,0,0,1,2.278,2.278"
          transform="translate(-468.787 -350.939)"
        />
        <path
          d="M474.876,444.64h-3.8a2.255,2.255,0,0,0-2.358,2.2v.4h8.432v-.4A2.186,2.186,0,0,0,474.876,444.64Z"
          transform="translate(-443.307 -418.546)"
        />
        <path
          d="M322.632,374.116a2.278,2.278,0,1,1-2.278-2.278,2.278,2.278,0,0,1,2.278,2.278"
          transform="translate(-303.411 -350.939)"
        />
        <path
          d="M296.8,444.64H293a2.255,2.255,0,0,0-2.358,2.2v.4h8.432v-.4A2.186,2.186,0,0,0,296.8,444.64Z"
          transform="translate(-277.935 -418.546)"
        />
      </g>
    </svg>
  );
};

export default Format;
